import type { ReactNode } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@zawarski/eti-ui';
import { EllipsisVertical } from 'lucide-react';
import IconButton from './IconButton';

export interface MoreMenuItem {
  title: string;
  /** Grey (#C2C2C2) icon shown at the right edge, like the legacy menus. */
  icon?: ReactNode;
  onClick: () => void;
}

/**
 * The header "more" menu of the legacy list pages: a white MoreVert button opening an eti-ui
 * DropdownMenu whose rows are "title ........ icon".
 */
const MoreMenu = ({
  items,
  ariaLabel = 'menu',
  buttonClassName,
}: {
  items: MoreMenuItem[];
  ariaLabel?: string;
  /** Restyles the button, e.g. the Palmetto 3.0 list header's square one (ListPageShell). */
  buttonClassName?: string;
}) => {
  if (!items.length) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <IconButton aria-label={ariaLabel} onDark className={buttonClassName}>
          <EllipsisVertical className='rep:size-6 rep:text-white' />
        </IconButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end' className='rep:min-w-55'>
        {items.map((item) => (
          <DropdownMenuItem
            key={item.title}
            onClick={item.onClick}
            className='rep:justify-between rep:text-base'>
            {item.title}
            <span className='rep:flex rep:text-[#C2C2C2]'>{item.icon}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MoreMenu;
